import { call, delay, select } from 'redux-saga/effects';

import * as Actions from '../../../actions';
import { getInDomain } from '../../../domains/externalUtils';
import { putAndWait } from '../../../sagas/TaskManager';
import Logger from '../../../tools/Logger';
import * as Utils from '../../../utils';

const log = Logger.child({ component: 'mediator/useCases/signout' });

export function* signOut({ payload: { postLogoutPath } }) {
  log.info('signout(): attempting to sign out current listener');

  const username = yield select(Utils.Listener.getCurrentUsername);
  yield select(Actions.UserAccount.removeAtCookie);

  try {
    if (username) {
      yield call(putAndWait, getInDomain('listener.actions.logout')(username));
      // the username in the action indicates we are transitioning from logged-in to anonymous
      // ..in this case only we clear the selected offer so it doesn't appear in the login/register page
      yield call(putAndWait, getInDomain('payments.actions.clearSelectedOffer')());
    }
    yield call(putAndWait, getInDomain('listener.actions.logoutFromCommunity')());

    // delay necessary to make sure logout data ends up in local persistence before the page
    // redirects (in particular Safari)
    yield delay(100);

    if (postLogoutPath) {
      yield call(Utils.Route.navigate, postLogoutPath);
    } else {
      yield call(Utils.Logout.navigateToLogin);
    }
  } catch (err) {
    log.error(`signOut(): failed with error: ${err.errorMessage}`);
  }
}
